export const CATALOGUES = "catalogues";

export const SEARCH = "search";

export const SOURCES = "sources";

export const POINTING = "pointing"

export const AUTH = "auth";

export const MALSAPI="mals/api"